{
  "version": 1,
  "asset_id": "0588e6df-ffbb-4ee3-bf1c-68151f494bef",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/0588e6df-ffbb-4ee3-bf1c-68151f494bef/sleeve-to-bypass-first-view-es-320.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/0588e6df-ffbb-4ee3-bf1c-68151f494bef/sleeve-to-bypass-first-view-es-320.webp",
  "original_filename": "sleeve-to-bypass-first-view-es-320.webp",
  "size": 11536,
  "content_type": "image/webp",
  "created_at": "2026-10-05T12:33:58Z"
}
